// extracted by css-extract-rspack-plugin
export default {"setOffset":"_e75b8c4a","viewportContainer":"_8a88d7b6","maxW1640px":"_f1741c4d","maxW1640Px":"_f1741c4d"};